import React from 'react'

const Loading = () => {
  return (
    <div className='h-100vh d-flex justify-content-center align-items-center '>
        <h1>
            Loading...
        </h1>
    </div>
  )
}

export default Loading